import type { ComponentType } from 'react';
import { BrickingMyPhone } from './components/BrickingMyPhone';
import { CheapPatriot } from './components/CheapPatriot';
import { HeavyIndustry } from './components/HeavyIndustry';
import { MagnoliaFlower } from './components/MagnoliaFlower';
import { VanDyke } from './components/VanDyke';

export interface Work {
  slug: string;
  title: string;
  year?: string;
  hasBottomSpacer?: boolean;
  headerOverlaysContent?: boolean;
  Component: ComponentType;
}

export const brickingMyPhoneWork: Work = {
  slug: 'bricking-my-phone',
  title: 'Bricking My Phone',
  year: '2026',
  headerOverlaysContent: true,
  Component: BrickingMyPhone,
};

export const heavyIndustryWork: Work = {
  slug: 'heavy-industry',
  title: 'Heavy Industry',
  year: '2026',
  headerOverlaysContent: true,
  Component: HeavyIndustry,
};

export const cheapPatriotWork: Work = {
  slug: 'cheap-patriot',
  title: 'Cheap Patriot',
  year: '2026',
  hasBottomSpacer: true,
  Component: CheapPatriot,
};

export const vanDykeWork: Work = {
  slug: 'van-dyke',
  title: 'Van Dyke',
  year: '2026',
  hasBottomSpacer: true,
  Component: VanDyke,
};

export const magnoliaFlowerWork: Work = {
  slug: 'magnolia-flower',
  title: 'Magnolia Flower',
  year: '2026',
  hasBottomSpacer: true,
  Component: MagnoliaFlower,
};

export const defaultWork = magnoliaFlowerWork;

export const works: Work[] = [
  magnoliaFlowerWork,
  vanDykeWork,
  cheapPatriotWork,
  heavyIndustryWork,
  brickingMyPhoneWork,
];

export function getWorkBySlug(slug: string | undefined): Work | undefined {
  return works.find((work) => work.slug === slug);
}
